import { render, staticRenderFns } from "./CommandView.vue?vue&type=template&id=22bbd4ae&scoped=true"
import script from "./CommandView.vue?vue&type=script&lang=js"
export * from "./CommandView.vue?vue&type=script&lang=js"
import style0 from "./CommandView.vue?vue&type=style&index=0&id=22bbd4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bbd4ae",
  null
  
)

export default component.exports